export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعادة العملية"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تاريخ العمليات"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قائمة الحسابات"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ غير معروف"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قائمة الرموز"])}
}